<template>
  <section class="ecom materials materials--accepted">
    <h2 class="ecom materials__header" id="acceptedMaterials">
      Accepted Materials
    </h2>
    <p class="ecom materials__text">
      Household junk and debris from construction or home improvement projects
      are typically allowed in a dumpster. Learn more about the items that can
      be thrown away in most areas.
    </p>

    <dismissable :showClose="false">
      <template v-slot:content>
        <p>
          Disclaimer: Accepted materials vary widely by location. Some commonly
          accepted materials may not be accepted in your location, or may carry
          additional fees. Have questions? Reach out by phone at
          <a class="custom-quote__phone" :href="`tel:${phoneNumber}`">{{
            phoneNumber
          }}</a>
          or LiveChat.
        </p>
      </template>
    </dismissable>

    <MaterialsAccordion>
      <template v-slot:icon>
        <img class="ecom materials-accordion__icon" :src="houseHold" />
      </template>
      <template v-slot:header>
        <p class="ecom materials-accordion__header">Mixed Household Trash</p>
      </template>
      <template v-slot:content>
        <div class="ecom materials-accordion__content">
          <ul class="materials__list">
            <li><img :src="imgPath" />Clothing &amp; Toys</li>
            <li><img :src="imgPath" />Wooden Furniture</li>
            <li><img :src="imgPath" />Kitchenware &amp; Decor</li>
          </ul>
          <p class="ecom sub__header">
            Restrictions or Additional Fees May Apply:
          </p>
          <ul class="materials__list">
            <li>
              <img
                class="exclamation__img"
                :src="exclamationImgPath"
              />
              Electronics
            </li>
            <li>
              <img
                class="exclamation__img"
                :src="exclamationImgPath"
              />
              Appliances
            </li>
            <li>
              <img
                class="exclamation__img"
                :src="exclamationImgPath"
              />
              Mattresses &amp; Box Springs
            </li>
            <li>
              <img
                class="exclamation__img"
                :src="exclamationImgPath"
              />
              Upholstered Furniture
            </li>
          </ul>
        </div>
      </template>
    </MaterialsAccordion>

    <MaterialsAccordion>
      <template v-slot:icon>
        <img class="ecom materials-accordion__icon" :src="construction" />
      </template>
      <template v-slot:header>
        <p class="ecom materials-accordion__header">Construction Debris</p>
      </template>
      <template v-slot:content>
        <div class="ecom materials-accordion__content">
          <ul class="materials__list">
            <li>
              <img :src="imgPath" />Tile, Flooring Materials &amp; Countertops
            </li>
            <li><img :src="imgPath" />Drywall &amp; Lumber</li>
            <li><img :src="imgPath" />Roof Shingles</li>
          </ul>
        </div>
      </template>
    </MaterialsAccordion>

    <MaterialsAccordion>
      <template v-slot:icon>
        <img class="ecom materials-accordion__icon" :src="yardWaste" />
      </template>
      <template v-slot:header>
        <p class="ecom materials-accordion__header">Yard Waste</p>
      </template>
      <template v-slot:content>
        <div class="ecom materials-accordion__content">
          <ul class="materials__list">
            <li><img :src="imgPath" />Shrubs &amp; Leaves</li>
            <li><img :src="imgPath" />Branches &amp; Logs</li>
          </ul>
          <p class="ecom sub__header">
            Restrictions or Additional Fees May Apply:
          </p>
          <ul class="materials__list">
            <li>
              <img class="exclamation__img" :src="exclamationImgPath" />Tree
              Stumps
            </li>
            <li>
              <img class="exclamation__img" :src="exclamationImgPath" />Dirt
            </li>
          </ul>
        </div>
      </template>
    </MaterialsAccordion>

    <MaterialsAccordion>
      <template v-slot:icon>
        <img class="ecom materials-accordion__icon" :src="heavy" />
      </template>
      <template v-slot:header>
        <p class="ecom materials-accordion__header">Heavy Materials</p>
      </template>
      <template v-slot:content>
        <div class="ecom materials-accordion__content">
          <p class="ecom sub__header">Availability Varies by Location:</p>
          <ul class="materials__list">
            <li><img :src="imgPath" />Brick</li>
            <li><img :src="imgPath" />Block</li>
            <li><img :src="imgPath" />Asphalt</li>
            <li><img :src="imgPath" />Concrete</li>
            <li><img :src="imgPath" />Rocks</li>
            <li><img :src="imgPath" />Dirt</li>
          </ul>
          <p class="ecom materials__moreinfo">
            <strong>Please note:</strong> If you’re throwing more than one type
            of heavy material in the same dumpster, give our team a call so we
            can find you the right dumpster rental.
          </p>
        </div>
      </template>
    </MaterialsAccordion>

    <p class="ecom materials__moreinfo">
      Want more info? Check out our
      <a :href="acceptedMaterials" target="_blank">
        Accepted &amp; Prohibited Materials Page
      </a>.
    </p>
  </section>
</template>

<script>
import MaterialsAccordion from '@/components/MaterialsAccordion.vue'
import Dismissable from '@/components/Dismissable.vue'
import config from '@/config'

const {
  cdn,
  phoneNumber,
  links: { acceptedMaterials }
} = config
export default {
  components: {
    MaterialsAccordion,
    Dismissable
  },
  data () {
    return {
      construction: `${cdn}icons-construction-accordion.svg`,
      yardWaste: `${cdn}icons-yard-waste-accordion.svg`,
      houseHold: `${cdn}icons-household-accordion.svg`,
      heavy: `${cdn}icons-heavy-stuff-accordion.svg`,
      imgPath: `${cdn}icons-accepted-items-checkmark.svg`,
      exclamationImgPath: `${cdn}icons-exclamation-mark.svg`,
      acceptedMaterials,
      phoneNumber
    }
  }
}
</script>
